import $ from 'jquery'
import Tools from '../Misc/Tools';

export class CoreApp {
    public settings: CoreAppSettings;
    public simKey: string;
    private isInited: boolean;
    public waitTilInited(): Promise<any> {
        return new Promise<any>((resolve) => {
            let interval: any = null;
            const check = () => {
                if(this.isInited) {
                    if(interval) {
                        clearInterval(interval);
                        interval = null;
                    }
                    
                    resolve(true);
                    return true;
                }
                return false;
            }
            if(!check()) {
                interval = setInterval(() => {
                    check();
                }, 250);
            }
        });
    }
    public init(onDone?: () => void) {
        const filePath = process.env.PUBLIC_URL + `/assets/env/${process.env.NODE_ENV}`;

        let url = new URL(window.location.href);
        let search_params = url.searchParams;
        this.simKey = search_params.get('simKey');

        const _onDone = () => {
            this.validateFields();

            if(onDone) {
                onDone();
            }
        }

        Tools.set508OutlineVisibleState(false);

        const onTabKeyUp = (e: any) => {
            if(e.key === 'Tab') {
                Tools.set508OutlineVisibleState(true);
                window.removeEventListener('keyup', onTabKeyUp);
            }
        }

        window.addEventListener('keyup', onTabKeyUp);

        jQuery.getJSON(filePath + '.json').then((data: CoreAppSettings) => {
            this.settings = data;
            this.isInited = true;
            Tools.set508FocusToBodyOfPage();
            if(process.env.NODE_ENV === 'development') {
                jQuery.getJSON(filePath + '.local.json').then((localData: CoreAppSettings) => {
                    this.settings = Object.assign({}, this.settings, localData);
                    _onDone();
                });
            } else {
                _onDone();
            }
            
        });
    }

    private validateFields() {
        if(!this.settings) {
            throw Error('app settings not defined')
        }

        if(this.settings.api_baseUrl && !this.settings.api_baseUrl.endsWith('/')) {
            this.settings.api_baseUrl += '/';
        }
    }
}

export const coreApp = new CoreApp();

export interface CoreAppSettings {
    api_baseUrl: string;
    useMockApi: boolean;
}